import Handlebars from 'handlebars/runtime';
import Moment from 'moment';

Handlebars.registerHelper('Strip', context => new Handlebars.SafeString(context));
Handlebars.registerHelper('Truncate', (str, len) => {
  if (str && str.length > len && str.length > 0) {
    let newStr = str;
    newStr = str.substring(0, len);
    newStr = str.substring(0, newStr.lastIndexOf(' '));
    newStr = newStr.length > 0 ? newStr : str.substring(0, len);

    return new Handlebars.SafeString(`${newStr}...`);
  }
  return new Handlebars.SafeString(str);
});
Handlebars.registerHelper('If_even', function t(conditional, options) {
  if (conditional % 2 === 0) {
    return options.fn(this);
  }
  return options.inverse(this);
});
Handlebars.registerHelper('Format_date', context => Moment(context).format('MMMM Do YYYY'));

// getElementById wrapper
function $id(id) {
  return document.getElementById(id);
}

// asyncrhonously fetch the html template partial from the file directory,
// then set its contents to the html of the parent element
function loadHTML(url, id) {
  const req = new XMLHttpRequest();
  req.open('GET', url);
  req.send();
  req.onload = () => {
    $id(id).innerHTML = req.responseText;
  };
}

// Animates scrolling in a predictable way accounting for interruptions
function animateScrollTop(target, durationtime) {
  const duration = durationtime || 16;
  const $window = $(window);
  const scrollTopProxy = {
    value: $window.scrollTop(),
  };
  let expectedScrollTop = scrollTopProxy.value;

  if (scrollTopProxy.value !== target) {
    $(scrollTopProxy).animate(
      {
        value: target,
      },
      {
        duration,

        step(stepValue) {
          const roundedValue = Math.round(stepValue);
          if ($window.scrollTop() !== expectedScrollTop) {
            // The user has tried to scroll the page
            $(scrollTopProxy).stop();
          }
          $window.scrollTop(roundedValue);
          expectedScrollTop = roundedValue;
        },

        complete() {
          if ($window.scrollTop() !== target) {
            setTimeout(() => {
              animateScrollTop(target);
            }, 16);
          }
        },
      },
    );
  }
}

function initPage() {
  $('#home-carousel-news').hide();
  $('#status').fadeOut();
  $('#preloader').delay(350).fadeOut();
  $('#home-carousel-news').fadeIn('slow');
}

// Export all the functions
export default {
  $id,
  loadHTML,
  animateScrollTop,
  initPage,
  Handlebars,
};
